import { type DataTypeType } from '@repo/advanced-filters';
import { type DataTypeConfigType } from '@repo/utils';

export const getActivityAttributes = `
query activityAttributes($activityId: Int){
  activityAttribute (activityId: $activityId){
    id
    activityId
    attributeName
    schemaName
    dataType
    isMandatory
    dataTypeConfig {
      decimalScale
      inputTypeConfig
      maxTextLength
      dropdownRenderType
    }
  }
}
`;

export interface ActivityAttribute {
  id: string;
  activityId: string;
  attributeName: string;
  schemaName: string;
  dataType: DataTypeType;
  isMandatory: boolean;
  dataTypeConfig: DataTypeConfigType;
}

export interface GetActivityAttributesProps {
  activityAttribute: ActivityAttribute[];
}
